// extracted by mini-css-extract-plugin
module.exports = {"maxWidthSmallScreenDesktop":"960px","dotsWrapper":"dots_dotsWrapper__7OeFl","dotSmall":"dots_dotSmall__wQ9mv","dot":"dots_dot__gl5Id","activeDot":"dots_activeDot__rR_iD"};